import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type SortNumDescendIconProps = IconProps;

export const SortNumDescendIcon = forwardRef<
  SVGSVGElement,
  SortNumDescendIconProps
>(function SortNumDescendIcon(props: SortNumDescendIconProps, ref) {
  return (
    <Icon
      data-testid="SortNumDescendIcon"
      aria-label="sort num descend"
      viewBox="0 0 12 12"
      ref={ref}
      {...props}
    >
      <path d="M3.22 12.066h-.807V8.85c0-.107.001-.215.004-.322l.007-.314c.004-.103.01-.2.017-.294a7.883 7.883 0 0 1-.397.362l-.574.458-.403-.509L2.55 7.069h.67v4.997ZM4.4 2.194c0 .297-.02.587-.064.872a3.233 3.233 0 0 1-.219.8 2.121 2.121 0 0 1-.427.66c-.18.189-.408.337-.684.444-.275.107-.608.16-.998.16-.098 0-.212-.005-.341-.017a2.224 2.224 0 0 1-.315-.04v-.67a2.23 2.23 0 0 0 .615.081c.422 0 .75-.078.985-.235.237-.158.404-.374.502-.65.1-.276.157-.589.171-.94h-.041a1.16 1.16 0 0 1-.622.516 1.628 1.628 0 0 1-.54.079c-.287 0-.538-.06-.752-.181a1.245 1.245 0 0 1-.496-.527A1.855 1.855 0 0 1 1 1.71c0-.353.067-.657.202-.913.134-.255.324-.45.57-.588C2.02.07 2.308 0 2.641 0c.25 0 .482.046.693.137.215.089.402.225.561.41.16.182.284.411.373.687.088.273.133.593.133.96ZM2.65.664a.808.808 0 0 0-.618.255c-.16.169-.239.429-.239.78 0 .285.068.51.205.676.137.167.346.25.629.25.196 0 .365-.04.506-.12a.91.91 0 0 0 .331-.31.706.706 0 0 0 .12-.383c0-.135-.02-.27-.058-.404a1.188 1.188 0 0 0-.171-.369.902.902 0 0 0-.294-.27.774.774 0 0 0-.41-.106ZM9 9.105V1H8v8.089L6.408 7.5l-.708.706 2.808 2.803 2.8-2.795-.708-.706L9 9.105Z" />
    </Icon>
  );
});
